import React from 'react';
import Page from '../components/Page';
import { graphql } from 'gatsby';
import Hero from '../components/Hero';
import DownloadSection from '../components/DownloadSection';
import ShortSection from '../components/ShortSection';
import LargeCardsSection from '../components/LargeCardsSection';
import DemoBanner from '../components/DemoBanner';
import BlocksSection from '../components/BlocksSection';
import ResourcesSection from '../components/ResourcesSection';
import PageMeta from '../components/PageMeta';

const SolutionPage = ({ data }) => {
  const {
    hero,
    downloadSection,
    shortSections,
    largeCardsSection,
    ctaBanner,
    blocksSection,
    resourcesSection,
    pageMeta,
  } = data.contentfulSolutionPage;

  return (
    <Page>
      <PageMeta {...pageMeta} />
      <Hero {...hero} />
      <DownloadSection {...downloadSection} />
      {shortSections.map((section, i) => {
        return (
          <ShortSection
            backgroundColor={'grey'}
            {...section}
            key={`${i}-${section.title}`}
          />
        );
      })}
      <LargeCardsSection
        backgroundColor={'grey'}
        withDecoration
        {...largeCardsSection}
      />
      <ResourcesSection {...resourcesSection} />
      <DemoBanner {...ctaBanner} />
      <BlocksSection {...blocksSection} />
    </Page>
  );
};

export default SolutionPage;

export const query = graphql`
  query SolutionPagePageQuery($contentful_id: String!) {
    contentfulSolutionPage(contentful_id: { eq: $contentful_id }) {
      pageMeta {
        ...PageMeta
      }
      hero {
        ...Hero
      }
      downloadSection {
        ...DownloadSection
      }
      shortSections {
        ...ShortSection
      }
      largeCardsSection {
        ...LargeCardsSection
      }
      resourcesSection {
        ...ResourcesSection
      }
      ctaBanner {
        ...CTABanner
      }
      blocksSection {
        ...BlocksSection
      }
    }
  }
`;
